<div>
  {{ description }}
</div>

<ng-container *ngIf="showCalculator">

  <div class="mt-4">
    <!-- Filters -->
    <yc-top-level-filters *ngIf="formGroup"
      [formGroup]="formGroup"
      [topLevelFilters]="topLevelFilters"
      [hideTableOptions]="true"
      [filtersEvenlySpaced]="true"
      [optionsOnNewRow]="true"
      [repository]="repository"
      (onTopLevelFilterChange)="onTopLevelFilterChange($event)">
    </yc-top-level-filters>
  </div>


  <div class="items-wrapper"
    [formGroup]="headerFormGroup">
    <div class="items-header">
      <!-- Select all -->
      <div class="header left">
        <yc-checkbox
          name="selectAll"
          [optionLabelSrOnly]="true"
          [optionLabel]="'common:textSelectAll' | ycI18n: 'Select all'"
          (onClick)="toggleSelectAll()">
        </yc-checkbox>
      </div>
      <!-- Items -->
      <div class="header">
        <yc-i18n
          key="common:lblItems">
        </yc-i18n>
      </div>
      <!-- Value Per Item Header -->
      <div class="header">
        <yc-i18n
          key="GLOBAL:textValuePerItem"
          defaultValue="Value per item">
        </yc-i18n>
      </div>
      <!-- Units Header-->
      <div class="header">
        <yc-i18n
          key="common:textUnits">
        </yc-i18n>
      </div>
      <!-- Total Value Header -->
      <div class="header right">
        <yc-i18n
          key="GLOBAL:textTotalValue"
          defaultValue="Total value">
        </yc-i18n>
      </div>
    </div>
    
    <!-- Items List -->
    <cdk-virtual-scroll-viewport itemSize="30"
      class="viewport">
      <ng-container 
        *cdkVirtualFor="let item of repository.currentSet; trackBy: trackBy;
        let index = index;">
        <div class="items-list">
          <div class="items-row">
            <!-- Select -->
            <div class="item left">
              <yc-checkbox
                [(value)]="item.selected"
                [optionLabelSrOnly]="true"
                [optionLabel]="'common:textSelectRow' | ycI18n: 'Select row'"
                (valueChange)="setTotalsLine()">
              </yc-checkbox>
            </div>
            <!-- Items -->
            <div class="item text">
              {{ item.name }}
              <small class="d-block">
                <yc-i18n
                  key="BUDGET:textNumberUnitsRemaining"
                  [context]="{
                    number: (
                      (itemsRemainingMap[item.identification] - +item.unitsEntered) < 0 ?
                        0 :
                        itemsRemainingMap[item.identification] - +item.unitsEntered
                    ) | number
                  }"
                  defaultValue="__number__ units remaining">
                </yc-i18n>
              </small>
            </div>
            
            <!-- Value Per Item  -->
            <div class="item text-right">
              {{ item.value | gcMoney }}
            </div>
          
            <!-- Units -->
            <div class="item">
              <yc-input
                [(value)]="item.unitsEntered"
                [isNumber]="true"
                [min]="0"
                [label]="'common:textUnits' | ycI18n: 'Units'"
                [srOnlyLabel]="true"
                [numberOfDecimals]="0"
                (onChange)="setTotalMapPerRow(item, $event)">
              </yc-input>
            </div>
            
            <!-- Total Value  -->
            <div class="item right text-right">
              {{ totalMap[item.identification] | gcMoney }}
            </div>
          </div>
        </div>
      </ng-container>
    </cdk-virtual-scroll-viewport>

    <!-- Totals -->
    <div class="totals-line">
      <!-- Total Selected -->
      <div class="total total-selected">
        <yc-i18n
          key="GLOBAL:textNumberSelected"
          [context]="{
            number: totalSelected | number
          }"
          defaultValue="__number__ selected">
        </yc-i18n>
      </div>
      <!-- Total Units -->
      <div class="total total-units">
        <yc-i18n
          key="GLOBAL:textNumberUnits"
          [context]="{
            number: totalUnits | number
          }"
          defaultValue="__number__ units">
        </yc-i18n>
      </div>
      <!-- Total Value -->
      <div class="total total-value">
        <yc-i18n
          key="GLOBAL:textTotalAmount"
          defaultValue="Total amount">
        </yc-i18n>: 
        {{ totalValue | gcMoney }}
      </div>
    </div>
  </div>
</ng-container>